import { Box } from "@mui/material";
import { ReactComponent as SquareBox } from "assets/background/SquareBox.svg";
import React, { useEffect, useState } from "react";

import ZoomInAndHideAnimation from "./ZoomInAndHideAnimation";

function XaneLoader() {
  const [showSquareBox, setShowSquareBox] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowSquareBox((prev) => !prev);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      {showSquareBox ? (
        <Box position="relative" display="inline-block" height="100px">
          <SquareBox
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          {/* Line with vertical animation within the Box height */}
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="85%"
            sx={{
              animation: "moveLine 4000ms linear infinite",
              display: "flex",
              justifyContent: "center",
              marginTop: "5px",
            }}
          >
            <Box
              sx={{
                width: 84,
                height: "1px",
                flexShrink: 0,
                backgroundColor: "#4BC4F4",
                boxShadow: "0px 0px 24px 10px rgba(75, 196, 244, 0.2)",
              }}
            />
          </Box>
        </Box>
      ) : (
        <Box>
          <ZoomInAndHideAnimation />
        </Box>
      )}

      {/* Keyframes for vertical line animation */}
      <style>
        {`
          @keyframes moveLine {
            0% { transform: translateY(0); }
            50% { transform: translateY(100%); }
            100% { transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  );
}

export default XaneLoader;
